import React from 'react';
import { Lightbulb, Plus, Trash2 } from 'lucide-react';

const inputClass =
  'w-full rounded-xl border border-primary/15 bg-card px-4 py-3 text-sm text-foreground outline-none transition-colors placeholder:text-muted-foreground/55 focus:border-primary/60 focus:ring-2 focus:ring-primary/15';
const labelClass = 'mb-1.5 block text-xs font-medium text-foreground/85';

export function ProductMarketingEditor({
  details,
  section,
  onDetailChange,
  onBenefitChange,
  onAddBenefit,
  onRemoveBenefit,
}) {
  const benefits = details.benefits || [];

  return (
    <fieldset className="sm:col-span-2 lg:col-span-12 overflow-hidden rounded-[1.75rem] border border-primary/20 bg-background p-4 shadow-soft sm:p-6">
      <legend className="sr-only">Előnyök, érdekesség és záró üzenet</legend>
      <div className="mb-5 flex items-start gap-4">
        <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#D7B55B] text-[#0B2F22]">
          <Lightbulb className="h-4 w-4" strokeWidth={1.9} />
        </span>
        <div>
          <h3 className="font-display text-lg font-semibold text-primary">
            Előnyök, érdekesség és záró üzenet
          </h3>
          <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
            Minden rövid előny mellé adj egy tömör „Tudtad?” magyarázatot. Az újabb párok új sorokban jelennek meg.
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {benefits.map((benefit, index) => (
          <div key={`benefit-${index}`} className="rounded-2xl border border-primary/10 bg-secondary/45 p-4">
            <div className="mb-3 flex items-center justify-between">
              <span className="text-xs font-semibold text-[#B28D2F]">{index + 1}. előny</span>
              <button
                type="button"
                onClick={() => onRemoveBenefit(section, index)}
                className="inline-flex h-7 w-7 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-primary/10 hover:text-primary"
                aria-label={`${index + 1}. előny törlése`}
              >
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
            <div className="grid gap-4 md:grid-cols-[0.42fr_0.58fr]">
              <div>
                <label className={labelClass}>Rövid előny</label>
                <input
                  value={benefit.title}
                  onChange={(event) => onBenefitChange(section, index, 'title', event.target.value)}
                  className={inputClass}
                  placeholder="pl. Kíméletes, mégis hatékony"
                />
              </div>
              <div>
                <label className={labelClass}>„Tudtad?” – rövid magyarázat</label>
                <textarea
                  value={benefit.description}
                  onChange={(event) => onBenefitChange(section, index, 'description', event.target.value)}
                  className={`${inputClass} min-h-20 resize-y`}
                  placeholder="Röviden magyarázd el az előnyt."
                />
              </div>
            </div>
          </div>
        ))}
        {benefits.length < 4 ? (
          <button
            type="button"
            onClick={() => onAddBenefit(section)}
            className="flex min-h-28 w-full flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-primary/25 bg-primary/[0.035] text-primary transition-colors hover:bg-primary/[0.07]"
          >
            <Plus className="h-5 w-5" />
            <span className="text-xs font-medium">Előny hozzáadása</span>
          </button>
        ) : null}
      </div>

      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        <div>
          <label className={labelClass}>Záró CTA címe</label>
          <input
            value={details.ctaTitle}
            onChange={(event) => onDetailChange(section, 'ctaTitle', event.target.value)}
            className={inputClass}
            placeholder="Rövid, figyelemfelkeltő cím"
          />
        </div>
        <div>
          <label className={labelClass}>Záró CTA leírása</label>
          <input
            value={details.ctaText}
            onChange={(event) => onDetailChange(section, 'ctaText', event.target.value)}
            className={inputClass}
            placeholder="Rövid, meggyőző zárómondat"
          />
        </div>
      </div>
    </fieldset>
  );
}
